// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__2Q_vf","empty":"ModalGraph_empty__l12lh"};